import React from "react";
import "./WhyChooseUs.css";
import checkIcon from "../assets/check.svg"; 

export default function WhyChooseUs() {
  const points = [
    "Honest pricing without hidden markups",
    "Consistent quality across all product lines",
    "Excellent weather resistance for Pakistan’s climate",
    "Superior coverage reducing paint consumption",
    "Reliable customer service and technical support",
    "Four decades of proven performance",
    "Strong local presence, especially in Sindh Province",
  ];

  return (
    <section className="whychooseus-container">
      <div className="whychooseus-box">
        <h2>Why Customers Choose Glamur Paints</h2>
        <p className="subtitle">
          Based on customer feedback, here’s why families and professionals across Pakistan prefer Glamur Paints:
        </p>

        <div className="points-grid">
          {points.map((point, index) => (
            <div key={index} className="point-item">
              <img src={checkIcon} alt="check" className="check-icon" />
              <span>{point}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
